import { render, staticRenderFns } from "./SendGrid.vue?vue&type=template&id=0e9bed95&scoped=true"
import script from "./SendGrid.vue?vue&type=script&lang=js"
export * from "./SendGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9bed95",
  null
  
)

export default component.exports